export default __webpack_public_path__ + "static/product-education-cf3014c03e728b06abcb8d581b52619f.mp4";